import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextView = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M15.75 3H2.25V4.5H15.75V3ZM15.75 8.25H6V9.75H15.75V8.25ZM15.75 13.5H6V15H15.75V13.5ZM3.75 8.25H2.25V15H3.75V8.25Z",
			fill: "currentColor"
		})
	})
});
export default SvgTextView;
